import { Select, SelectItem } from "@heroui/react";
import { useTranslation } from "react-i18next";

export type WeightUnit = "kg" | "lb";
export type DimensionUnit = "cm" | "in";

interface UnitSelectorProps {
  value: string;
  onValueChange: (value: string) => void;
  type: "weight" | "dimension";
  className?: string;
}

export function UnitSelector({
  value,
  onValueChange,
  type,
  className,
}: UnitSelectorProps) {
  const { t } = useTranslation("app");
  const options =
    type === "weight"
      ? [
          { value: "kg", label: "kg" },
          { value: "lb", label: "lb" },
        ]
      : [
          { value: "cm", label: "cm" },
          { value: "in", label: "in" },
        ];

  return (
    <Select
      aria-label={
        type === "weight"
          ? t("unitSelector.weight")
          : t("unitSelector.dimension")
      }
      size="sm"
      variant="bordered"
      selectedKeys={[value]}
      onSelectionChange={(keys) => {
        const v = Array.from(keys)[0];
        if (typeof v === "string") onValueChange(v);
      }}
      className={className}
    >
      {options.map((option) => (
        <SelectItem key={option.value}>{option.label}</SelectItem>
      ))}
    </Select>
  );
}
